import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import routes from './routes'
import validate from './plugins/validate/index.js'
import layer from './plugins/layer/index.js'
import ajax from './plugins/ajax/index.js'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.css'
import './assets/scss/index.scss'
import Tab from '@/components/tab/Index.vue'
import storage from './plugins/storage/index.js'
import row from './plugins/row/index.js'
import { myTime } from '@/assets/js/ulits.js'
// import socket from './plugins/socket/index.js'
// Vue.use(socket)
import indexdb from './plugins/indexdb/index.js'
Vue.use(indexdb)
import VueBarcodeScanner from './plugins/barcode-scanner/index.js'
import VueClipboard from 'vue-clipboard2'
import 'vue-easytable/libs/themes-base/index.css'
import { VTable, VPagination } from 'vue-easytable'
import hotkeys from 'hotkeys-js'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import echarts from 'echarts'
import messageOrder from '@/plugins/message/index.js'
Vue.prototype.$echarts = echarts
Vue.use(VueClipboard)
Vue.use(VueBarcodeScanner)
Vue.use(validate)
Vue.use(layer)
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(storage)
Vue.use(row)
Vue.use(hotkeys)
Vue.use(preview, {
	clickToCloseNonZoomable: false
})
Vue.use({
	install() {
		Vue.prototype.$eventBus = new Vue()
	}
})
const router = new VueRouter({
	routes
})
Vue.use(ajax, router)
Vue.use(messageOrder, router)
Vue.component('x-tab', Tab)
Vue.component(VTable.name, VTable)
Vue.component(VPagination.name, VPagination)
Vue.mixin({
	methods: {
		formateTime: myTime
	}
})
// 全局路由守卫
router.beforeEach((to, from, next) => {
	let userInfo = localStorage.getItem('userInfo')
	if (to.path == '/login') {
		if (userInfo) {
			next({
				path: '/index'
			})
		} else {
			next()
		}
		return
	}
	if (userInfo) {
		// 如果当前用户信息已经存在直接进入首页
		if (to.name === 'home') {
			next({
				path: '/index'
			})
		} else {
			next()
		}
	} else {
		next({
			path: '/login',
			replace: true
		})
	}
})
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')

if (typeof Object.fromEntries == "undefined") {
	//扩展Object对象拥有二维数组转对象的原型方法
	Object.fromEntries = function (Arr) {
		let Obj = {}
		for (let item of Arr) {
			Obj[item[0].toString()] = item[1]
		}
		return Obj
	}
}



// WEBPACK FOOTER //
// ./src/main.js